// libraries
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import Image from './../../utils/components/Image';

import homeImageFile from '../../public/homeImage.png';
import logoKJ from '../../public/logoKJCropped.png';

function Home() {
  return (
    <>
      <img src={logoKJ} width="95%"></img>
      <div className="socials">
      <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://kjsieit.somaiya.edu"
          className="social-icon icon-only li"
        >
          <i className="fa fa-globe" />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.youtube.com/c/KJSIEITofficial"
          className="social-icon icon-only yt"
        >
          <i className="fab fa-youtube" />
        </a>
        <a
          href="https://www.facebook.com/kjsieitofficial"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon icon-only li"
        >
          <i className="fab fa-facebook-square" />
        </a>
        <a
          href="https://www.instagram.com/kjsieit_22"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon icon-only gi"
        >
          <i className="fab fa-instagram" />
        </a>
      </div>

      {/* <h1 style={{textAlign:"center"} }className="info"> <img src={somaiyaLogo } width="20%" height="20%"></img> K. J. Somaiya Institute of Engineering and Information Technology</h1> */}
      <div className="home">
        <Helmet>
          <title>
            Home - K. J. Somaiya Institute of Engineering and Information
            Technology{' '}
          </title>
          <meta
            name="description"
            content="K. J. Somaiya Institute of Engineering and Information Technology"
          />
        </Helmet>

        <div className="details">
          {/* <img width="70%" height="80%" src="https://kjsieit.somaiya.edu/assets/kjsieit/images/Logo/kjsieit-logo.svg"></img> */}
          {/* <h1 className="title" > K. J. Somaiya Insititute of Engineering & Information Technology </h1> 
			<h3 className="info" > Department of Information Technology </h3>
	    	 <p className="paragraph">
			Information Technology is at the forefront of innovation and is a driving force in the digital transformation of the world. Therefore, graduates of Information Technology degrees take up stimulating employment with national and global industry leaders. The Bachelor of Engineering in Information Technology (B.E. I.T.) programme provides the skills required succeed at the cutting edge of the digital economy.
				{/* <br/>Note: these predictions are bases on a Worst-Case scenario.
				<br/>#StaySafe 
			</p>
			*/}
          
          <div className="btns">
            <Link to="/events" className="btn-primary hg">
              Download Certificates of <br></br>Recent Events
            </Link>
          </div>
        </div>
        <div className="image">
          <Image src={homeImageFile} />
        </div>
      </div>
    </>
  );
}

export default Home;
